import { Link } from "react-router-dom";

export default function SubmitBanner() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-8 md:px-6 md:py-10">
        <div className="relative overflow-hidden rounded-lg">
          <div className="absolute inset-0 h-full w-full">
            <img
              src="https://readdy.ai/api/search-image?query=cinematic%20warm-toned%20abstract%20image%20of%20glowing%20amber%20city%20lights%20at%20night%20with%20bokeh%20and%20film%20grain%2C%20deep%20coral%20highlights%2C%20editorial%20moody%20atmosphere%2C%20no%20visible%20faces&width=1600&height=500&seq=bg-cta-01&orientation=landscape"
              alt="爆料投稿通道"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-primary-900/50" />
          <div className="relative flex flex-col items-start gap-5 p-7 md:flex-row md:items-center md:justify-between md:p-10">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-megaphone-line" aria-hidden="true" />
                全民爆料
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                你手里也有瓜？投给我们就对了
              </h2>
              <p className="mt-2 max-w-xl text-sm leading-6 text-background-200">
                匿名投稿、线索核实、编辑整理三步走。我们会对来源做基本核对，未经证实的信息不会以定论的形式呈现。
              </p>
            </div>
            <Link
              to="/contact"
              className="flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-300"
            >
              <i className="ri-send-plane-fill" aria-hidden="true" />
              立即投稿
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}